/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_10f4c027',
  item: 'item_10f4c027',
};

export = styles;

loadStyles([{"rawString":".root_10f4c027{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.item_10f4c027{-ms-flex-negative:0;flex-shrink:0}"}]);
/* tslint:enable */